export { GroupsPage } from './GroupsPage'
export { groupsReducer } from './reducers'


// WEBPACK FOOTER //
// ./src/App/Admin/Groups/index.js